import { brandPrimaryText, darkGrayFontColor, urgentDate } from '@Styles/colors';
import { CssSelectors, Layouts, baseStyles, truncateTextStyle } from '@Styles/styles';
import { CSSProperties, StyleSheet } from 'aphrodite';

export const RedtailUsersBorder = '1px solid #D8D8D8';

export const styleSheet = StyleSheet.create({
	actionEntities: {
		':first-child': {
			marginBottom: 10,
		},
		':nth-child(2)': {
			marginBottom: 10,
		},
		':nth-child(3)': {
			marginBottom: 10,
		},
		alignItems: 'center',
		color: darkGrayFontColor,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
		justifyContent: 'flex-start',
		width: '100%',
		...CssSelectors.allChildren(
			{
				display: 'flex',
				justifyContent: 'center',
				minWidth: 22,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				paddingLeft: 10,
			},
			':last-child'
		),
	},
	availableOption: {
		margin: '4px 0 0',
	},
	availableOptions: {
		flexGrow: 1,
	},
	availableOptionsContainer: {
		...Layouts.horizontalStack(20),
	},
	availableOptionsInfoField: {
		...CssSelectors.allChildren(
			{
				height: 'auto',
				maxHeight: 162,
				overflow: 'auto',
			},
			':last-child'
		),
	},
	availableOptionsWrapper: {
		height: 220,
		margin: 0,
		width: 'calc(50% - 12px)',
	},
	button: {
		margin: '0 auto',
		marginTop: 16,
	},
	buttonContainer: {
		alignItems: 'flex-end',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'flex-end',
		...CssSelectors.allChildren(
			{
				display: 'flex',
				fledWrap: 'wrap',
				justifyContent: 'flex-end',
				marginBottom: 10,
				...CssSelectors.allChildren({
					marginTop: 5,
					minWidth: 0,
				}),
			},
			':first-child'
		),
	},
	card: {
		border: '1px solid #D3DBDE',
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.100034)',
		maxWidth: 400,
		padding: 16,
	},
	cardGroup: {
		alignItems: 'stretch',
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		display: 'flex',
		margin: '24px 0',
		padding: '20px 30px',
	},
	cardGroupColumn: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		height: 'auto',
		marginRight: 36,
		maxWidth: 300,
		...CssSelectors.allChildren(
			{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				minHeight: 60,
				...CssSelectors.allChildren({
					justifyContent: 'flex-start',
				}),
			},
			':not(.button-container)'
		),
	},
	cardGroupColumnEnd: {
		marginRight: 0,
		width: 140,
		...CssSelectors.allChildren(
			{
				alignItems: 'flex-end',
				justifyContent: 'flex-start',
			},
			':not(.button-container)'
		),
	},
	cardImage: {
		display: 'block',
		margin: '0 auto',
	},
	cardItem: {},
	container: {
		color: '#4A4A4A',
		fontSize: 14,
		paddingBottom: 16,
	},
	copyApiTokenButton: {
		alignItems: 'center',
		display: 'flex',
	},
	copyApiTokenButtonIcon: {
		marginLeft: 10,
	},
	copyButton: {
		marginLeft: 10,
	},
	disabled: {
		opacity: 0.5,
	},
	error: {
		alignItems: 'center',
		background: '#FFE7EA',
		border: `1px solid ${urgentDate}`,
		borderRadius: 3,
		display: 'inline-block',
		padding: '14px 20px 14px 10px',
	},
	icon: {
		margin: 16,
		maxWidth: 300,
	},
	infoField: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingBottom: 10,
		...CssSelectors.allChildren(
			{
				height: 'auto',
			},
			':last-child'
		),
	},
	infoFieldEditing: {
		marginBottom: 0,
	},
	instructionsText: {
		marginBottom: 32,
	},
	labelText: {
		marginBottom: 8,
		marginTop: 16,
	},
	labelWithResync: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: 190,
	},
	loadingSpinner: {
		position: 'relative',
	},
	modal: {},
	nasasoftLogo: {
		maxHeight: 70,
	},
	redtailMapping: {
		paddingTop: 20,
	},
	redtailUser: {
		':not(:last-child)': {
			borderBottom: RedtailUsersBorder,
		},
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		padding: 20,
	},
	redtailUserHeader: {
		color: '#AAAAAA',
		fontSize: 11,
		letterSpacing: '1.1px',
		textTransform: 'uppercase',
	},
	redtailUserHeaders: {
		alignItems: 'center',
		borderBottom: RedtailUsersBorder,
		display: 'flex',
		flexDirection: 'row',
		padding: '0 20px 20px',
	},
	redtailUserLastDate: {
		width: '25%',
	},
	redtailUserName: {
		width: '30%',
	},
	redtailUsers: {},
	redtailUsersContainer: {
		flexDirection: 'column',
	},
	redtailUserStatus: {
		paddingLeft: 30,
		width: '20%',
	},
	redtailUsersText: {
		fontSize: 14,
		fontWeight: 600,
		padding: '20px 20px 0',
	},
	section: {
		':not(:last-child)': {
			marginBottom: 20,
		},
	},
	sectionTitle: {
		...Layouts.horizontalStack(10),
		alignItems: 'flex-end',
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 24,
		marginBottom: 10,
	},
	selectAvailableOptionsOption: {
		width: '35vw',
	},
	selectContainer: {
		width: 190,
	},
	selectOption: {
		width: 188,
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 30,
		minWidth: 165,
	},
	statusIndicator: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				height: 20,
				margin: '0 10px 0 -30px',
				width: 20,
			},
			'span'
		),
	},
	statusIndicatorActive: {
		marginRight: 10,
	},
	statusIndicatorInactive: {
		opacity: 0.5,
	},
	stepText: {
		marginBottom: 16,
		marginTop: 16,
	},
	syncText: {
		margin: '0 auto',
		marginBottom: 8,
		textAlign: 'center',
	},
	tagList: {
		marginTop: -15,
	},
	text: {
		color: '#4A4A4A',
		fontSize: 14,
	},
	textInput: {
		flex: 1,
		maxWidth: 500,
	},
	textInputContainer: {
		display: 'flex',
		flexDirection: 'row',
	},
	userCredentialsLink: {
		marginLeft: 8,
	},
	writeBackTrigger: {
		...truncateTextStyle,
	},
});
